import type { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  content: { minWidth: theme.spacing(40) },
}))

export default useStyles
